<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12">
                <h6>Nuevo cliente</h6>
              </div>
            </div>
          </div>
          <form-cliente
            :estados="estados"
            :municipios="municipios"
            modo="crear"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import FormCliente from "./components/FormCliente";

export default {
  name: "crear-cliente",
  components: {
    FormCliente,
  },
  data() {
    return {
      estados: [],
      municipios: [],
    };
  },
  methods: {
    async getEstados() {
      const response = await appApi().get("estados");
      this.estados = response.data;
    },
  },
  created() {
    this.getEstados();
  },
};
</script>
